export enum ViewStates {
    View = 'view',
    Editing = 'editing',
    Saving = 'saving',
}

export default ViewStates;